import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import * as detect from 'detect-browser';

@Injectable({
  providedIn: 'root'
})
export class UnsupportedVersionGuard implements CanActivate {
  public constructor(private readonly router: Router) {}

  public async canActivate(): Promise<boolean> {
    const browser = detect.detect();
    if ((browser.name === 'safari' || browser.name === 'ios') && parseInt(browser.version.split('.')[0]) < 16) {
      this.router.navigate(['/unsupported-version']).catch(console.error);
      return false;
    }
    return true;
  }
}
